<template>
  <div class="d-flex flex-wrap justify-content-center mb-1">
    <button
      v-for="star in 10"
      :key="star"
      type="button"
      class="btn p-0 border-0"
      :disabled="!edit"
      :class="intensity >= star ? 'text-warning' : 'text-muted'"
      style="cursor: pointer; font-size: 0.8rem;"
      @click="setIntensity(star)"
      @keydown.enter="setIntensity(star)"
      @keydown.space.prevent="setIntensity(star)">
      <font-awesome-icon icon="fa-solid fa-star" />
    </button>
  </div>
</template>

<script setup>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faStar);

defineProps({
  edit: {
    type: Boolean,
    default: false,
  },
  intensity: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['set-intensity']);

function setIntensity(star) {
  emit('set-intensity', star);
}
</script>
